import React, { useState } from 'react';
import InfoDialog from '../../../components/shared/InfoDialog';
import { useTranslation } from 'react-i18next';
import { Box, Link, Stack } from '@mui/material';
import CusInput from '../../../components/material-ui/CusInput';
import CusDatePicker from '../../../components/material-ui/CusDatePicker';

export default function PassportDetails({ open, closeModal, user }) {
  const { t } = useTranslation();
  const title = `${t("User's passport details")} ${user?.login}`;

  const onSaveClick = () => {};

  return (
    <InfoDialog
      open={open}
      onClose={closeModal}
      title={title}
      maxWidth="xs"
      onSaveClick={onSaveClick}>
      <Stack gap={1}>
        <CusInput label={'Surname'} />
        <CusInput label={'First name'} />
        <CusInput label={'Patronymic'} />
        <Box mt={1}>
          <CusDatePicker label={'Date of birth'} />
        </Box>
        <Box mt={1}>
          <CusDatePicker label={'Passport issue date'} />
        </Box>
        <CusInput label={'Passport series and number'} />
        <Link width={'fit-content'} component={'button'}>
          {t('Clear data')}
        </Link>
      </Stack>
    </InfoDialog>
  );
}
